import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import EmberArray from '@ember/array';
import { type IntervalDate } from 'donor-elf-web/lib/journal-utils';
import JournalModel from './journal';
import JournalGoalModel from './journal-goal';
import JournalSummaryDecisionModel from './journal-summary-decision';

export default class JournalSummaryDetailModel extends Model {
  @attr() declare fundId: string;
  @belongsTo('journal', { async: false, inverse: null })
  declare journal: JournalModel;
  @hasMany('journal-goal', { async: false })
  declare journalGoals: EmberArray<JournalGoalModel>;
  @hasMany('journal-summary-decision', { async: false })
  declare decisions: EmberArray<JournalSummaryDecisionModel>;
  @attr() declare intervalDates: IntervalDate[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'journal-summary-detail': JournalSummaryDetailModel;
  }
}
